import Author from "../../../../common/model/Author";

export default interface DocumentProcessingJob {
  id: number;
  batch_name: string;
  uploaded_by: Author | null;
  file_to_process: string;
  status: string;
  status_reason: string;
  documents_total_count: number;
  documents_indexed_count: number;
  documents_matched_count: number;
  documents_failed_count: number;
  date_created: string;
  date_issued: string;
  date_of_distribution: string;
  processingETA?: number;
  should_send_notifications?: boolean;
}

export const DocumentProcessingJobStatus = {
  PENDING_UPLOAD: "pending_upload",
  UPLOADED: "uploaded",
  PROCESSING: "processing",
  PROCESSED: "processed",
  MATCHING: "matching",
  MATCHED: "matched",
  PARTIALLY_MATCHED: "partially_matched",
  FAILED: "failed",
  PROCESSING_TIMEOUT: "processing_timeout",
  MATCHING_TIMEOUT: "matching_timeout",
  MATCHES_NEEDED: "matches_needed",
  CANCELLED: "cancelled",
  FINALIZING_PAYSLIPS: "finalizing",
  FINALIZED: "finalized",
  FINALIZED_WITH_ERRORS: "finalized_with_errors",
};

export const getDisplayStatus = (
  status: string,
  statusReason: string
): string => {
  if (
    status === DocumentProcessingJobStatus.FINALIZED &&
    statusReason &&
    !statusReason.trim().toLowerCase().startsWith("successfully")
  ) {
    return DocumentProcessingJobStatus.FINALIZED_WITH_ERRORS;
  }
  return status;
};

export interface DocumentProcessingJobWrapper {
  count: number;
  pages: number;
  results: DocumentProcessingJob[];
}
